import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { getTipoIncidentes, createTipoIncidente, updateTipoIncidenteById, deleteTipoIncidenteById } from "../api";

const FilterTableTipoIncidente = () => {
  const [tipoIncidentes, setTipoIncidentes] = useState([]);
  const [filteredTipoIncidentes, setFilteredTipoIncidentes] = useState([]);
  const [formData, setFormData] = useState({ id: 0, descripcion: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState("");
  const [filterText, setFilterText] = useState("");

  const fetchTipoIncidentes = async () => {
    try {
      const response = await getTipoIncidentes();
      setTipoIncidentes(response.data);
      setFilteredTipoIncidentes(response.data); // Initially show all items
    } catch (error) {
      console.error("Error fetching tipo incidentes:", error);
      setError("Error loading data");
    }
  };

  useEffect(() => {
    fetchTipoIncidentes();
  }, []);

  useEffect(() => {
    if (filterText) {
      const filtered = tipoIncidentes.filter((tipoIncidente) =>
        tipoIncidente.descripcion.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredTipoIncidentes(filtered);
    } else {
      setFilteredTipoIncidentes(tipoIncidentes);
    }
  }, [filterText, tipoIncidentes]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await updateTipoIncidenteById(formData.id, { descripcion: formData.descripcion });
        alert("Tipo de Incidente actualizado con éxito.");
      } else {
        await createTipoIncidente(formData);
        alert("Tipo de Incidente registrado con éxito.");
      }
      setFormData({ id: 0, descripcion: "" });
      setIsEditing(false);
      fetchTipoIncidentes();
    } catch (error) {
      console.error("Error procesando el tipo de incidente:", error);
    }
  };

  const handleEdit = (tipoIncidente) => {
    setFormData(tipoIncidente);
    setIsEditing(true);
  };

  const handleClearFilters = () => {
    setIsEditing(false);
    setFormData({ id: 0, descripcion: "" });
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de eliminar este tipo de incidente?")) {
      try {
        await deleteTipoIncidenteById(id);
        alert("Tipo de Incidente eliminado con éxito.");
        fetchTipoIncidentes();
      } catch (error) {
        console.error("Error eliminando el tipo de incidente:", error);
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <center><h2>{isEditing ? "Editar Tipo de Incidente" : "Agregar Tipo de Incidente"}</h2></center>
        <div className="input-group">
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            className="input"
            disabled={isEditing}
            hidden
          />
        </div>
        <div className="input-group">
          <label className="label3">Descripción</label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className="input-form-2"
          />
        </div>
        <center>
          <button type="submit" className="button-form-blue">
          {isEditing ? "Actualizar" : "Registrar"}
          </button>
          <button  type="reset" className="button-form-gray" onClick={handleClearFilters}>
              Cancelar
          </button>
        </center>
      </form>
      <hr />
      <div className="input-group">
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por descripción..."
          className="input2"
        />
      </div>
      {filteredTipoIncidentes.length === 0 ? (
        <p>{error || "Cargando datos..."}</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Descripción</th>
              <th colSpan="2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredTipoIncidentes.map((tipoIncidente) => (
              <tr key={tipoIncidente.id}>
                <td>{tipoIncidente.id}</td>
                <td>{tipoIncidente.descripcion}</td>
                <td>
                  <button onClick={() => handleEdit(tipoIncidente)} className="button-table-blue">
                    Editar
                  </button>
                </td><td>
                  <button onClick={() => handleDelete(tipoIncidente.id)} className="button-table-red">
                    Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

FilterTableTipoIncidente.propTypes = {
  tipo_incidente: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
    })
  ),
};

export default FilterTableTipoIncidente;
